import React, { useState } from "react";
import { Box, TextField, Button, IconButton, Stack, Paper, Typography } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";

const CommentBox = ({ onSubmit }) => {
    const [text, setText] = useState("");
    const [files, setFiles] = useState([]);

    const handleFileChange = (e) => {
        setFiles([...e.target.files]);
    };

    const handleSubmit = () => {
        if (!text.trim() && files.length === 0) return;
        onSubmit({ text, files });
        setText("");
        setFiles([]);
    };

    return (
        <Paper sx={{ p: 2, borderRadius: 2, mt: 2 }}>
            <Stack spacing={1}>
                <TextField
                    multiline
                    minRows={2}
                    placeholder="Write a comment..."
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    variant="outlined"
                    fullWidth
                />
                <Stack direction="row" spacing={1} alignItems="center">
                    <IconButton component="label">
                        <AttachFileIcon />
                        <input
                            hidden
                            type="file"
                            multiple
                            onChange={handleFileChange}
                        />
                    </IconButton>

                    {files.length > 0 && (
                        <Typography variant="body2" color="text.secondary">
                            {files.length} file(s) selected
                        </Typography>
                    )}

                    <Box flexGrow={1} />
                    <Button variant="contained" onClick={handleSubmit}>
                        Comment
                    </Button>
                </Stack>
            </Stack>
        </Paper>
    );
};

export default CommentBox;
